//@ts-check

if (!customElements.get("ff-variants-quantity-input")) {
  class FfVariantsQuantityInput extends HTMLElement {
    constructor() {
      super();

      if (!this.dataset.hasOwnProperty("ffDisabled")) {
        this.ffVariantsBtn = (() => {
          const ffVariantsBtn = document.querySelectorAll(
            `[data-ff-variants-quantity-input-id='${this.id}']`
          );

          if (ffVariantsBtn.length > 0) {
            return ffVariantsBtn;
          } else {
            throw new Error("Missing variants buttons");
          }
        })();

        this.ffInput = (() => {
          const ffInput = this.querySelector("input");

          if (ffInput) {
            return ffInput;
          } else {
            throw new Error("Missing variants buttons");
          }
        })();

        this.ffInput.value = "1";

        this.ffVariantsBtn.forEach((ffVariantBtn) => {
          ffVariantBtn.addEventListener("click", () =>
            this.ffInitVariant(ffVariantBtn)
          );
        });

        const ffInitialVariantBtn =
          Array.from(this.ffVariantsBtn).find((ffVariantBtn) =>
            ffVariantBtn.hasAttribute("data-ff-initial-active")
          ) || this.ffVariantsBtn[0];

        if (ffInitialVariantBtn) {
          this.ffInitVariant(ffInitialVariantBtn);
        }

        if (this.dataset.hasOwnProperty("ffNoInitBtn")) {
          this.ffInput.addEventListener(
            "change",
            this.ffOnInputChange.bind(this)
          );

          this.ffInput.addEventListener(
            "input",
            this.ffOnInputChange.bind(this)
          );

          this.querySelectorAll("[data-ff-variants-quantity-input-button]").forEach((button) =>
            button.addEventListener("click", this.ffOnButtonClick.bind(this))
          );
        } else {
          this.ffInitBtn = (() => {
            const ffInitBtn = this.querySelector(
              "[data-ff-variants-quantity-input-init-btn]"
            );

            if (ffInitBtn) {
              return ffInitBtn;
            } else {
              throw new Error("Missing init button");
            }
          })();

          this.ffInitBtn.addEventListener("click", () => this.ffInitInput(), {
            once: true,
          });
        }
      }
    }

    ffInitInput() {
      if (!this.ffVariantSelected) {
        this.ffVariantsBtn[0].click();
      }

      this.ffInput.addEventListener("input", this.ffOnInputChange.bind(this));

      this.querySelectorAll("[data-ff-variants-quantity-input-button]").forEach((button) =>
        button.addEventListener("click", this.ffOnButtonClick.bind(this))
      );

      this.ffUpdateSubscribeButtonPrice();
    }

    ffInitVariant(variantBtn) {
      this.ffVariantSelected = variantBtn;

      const { ffVariantBulkAddQuantity, ffVariantFormId } = variantBtn.dataset;

      this.ffInput.value = ffVariantBulkAddQuantity || "1";
      this.ffInput.setAttribute("form", ffVariantFormId || "");

      this.ffUpdateSubscribeButtonPrice();
    }

    ffOnInputChange(e) {
      if (!this.ffVariantSelected) {
        e.preventDefault();
        this.ffInput.value = "";
      } else {
        this.validateQtyRules();
        this.ffUpdateSubscribeButtonPrice();
      }
    }

    ffOnButtonClick(event) {
      event.preventDefault();

      if (this.ffVariantSelected) {
        const previousValue = this.ffInput.value;

        const button = event.target.closest("[data-ff-variants-quantity-input-button]");

        if (!button) return;

        if (button.dataset.ffName === "plus") {
          if (
            this.ffInput.dataset.min &&
            parseInt(this.ffInput.dataset.min) > parseInt(this.ffInput.step) &&
            this.ffInput.value == "0"
          ) {
            this.ffInput.value = this.ffInput.dataset.min;
          } else {
            this.ffInput.stepUp();
          }
        } else {
          this.ffInput.stepDown();
        }

        if (
          this.ffInput.dataset.min === previousValue &&
          button.dataset.ffName === "minus"
        ) {
          this.ffInput.value = this.ffInput.min;
        }

        this.ffVariantSelected.dataset.ffVariantBulkAddQuantity =
          this.ffInput.value;

        this.ffUpdateSubscribeButtonPrice();
      }
    }

    validateQtyRules() {
      const value = parseInt(this.ffInput.value);

      if (this.ffInput.min) {
        const buttonMinus = this.querySelector("[data-ff-name='minus']");

        if (buttonMinus) {
          buttonMinus.classList.toggle(
            "disabled",
            value <= parseInt(this.ffInput.min)
          );
        }
      }

      if (this.ffInput.max) {
        const max = parseInt(this.ffInput.max);

        const buttonPlus = this.querySelector("[data-ff-name='plus']");

        if (buttonPlus) {
          buttonPlus.classList.toggle("disabled", value >= max);
        }
      }

      if (this.ffVariantSelected) {
        this.ffVariantSelected.dataset.ffVariantBulkAddQuantity =
          this.ffInput.value;
      }
    }

    /**
     * 26.06.03 TEST A/B VWO - Mostrar precio dentro del CTA de suscripción
     *
     * Variante A (control):
     * CTA sin precio.
     *
     * Variante B (test):
     * CTA mostrando precio de suscripción y precio de compra tachado.
     *
     * El importe debe actualizarse dinámicamente cuando cambia
     * la variante o la cantidad seleccionada.
     */
    ffUpdateSubscribeButtonPrice() {
      if (!this.ffVariantSelected) return;

      const quantity = parseInt(this.ffInput.value, 10) || 1;
      const formId = this.ffVariantSelected.dataset.ffVariantFormId;

      if (!formId) return;

      const form = document.getElementById(formId);

      if (!form) return;

      const prices = form.querySelector(".ff-subscribe-button-prices");

      if (!prices) return;

      const subscriptionUnitPrice = parseInt(
        prices.dataset.subscriptionUnitPrice,
        10
      );

      const compareUnitPrice = parseInt(
        prices.dataset.compareUnitPrice,
        10
      );

      if (isNaN(subscriptionUnitPrice) || isNaN(compareUnitPrice)) return;

      const subscriptionTotal = subscriptionUnitPrice * quantity;
      const compareTotal = compareUnitPrice * quantity;

      const subscriptionPriceEl = prices.querySelector(
        ".ff-subscribe-button-price"
      );

      const comparePriceEl = prices.querySelector(
        ".ff-subscribe-button-compare-price"
      );

      if (subscriptionPriceEl) {
        subscriptionPriceEl.textContent = this.ffFormatMoney(subscriptionTotal);
      }

      if (comparePriceEl) {
        comparePriceEl.textContent = this.ffFormatMoney(compareTotal);
      }
    }

    ffFormatMoney(cents) {
      return (
        (cents / 100).toLocaleString("es-ES", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + "€"
      );
    }

    /**
     * TODO - TEST A/B VWO
     *
     * Revisar resultados del experimento.
     * Eliminar o mantener este código según el resultado ganador.
     */
  }

  customElements.define("ff-variants-quantity-input", FfVariantsQuantityInput);
}